// Ukrainian translations
export const uk: Record<string, string> = {
  'menu.dashboard': 'Панель керування',
  'menu.orderNew': 'Реєстрація продукту',
  'menu.deliveryList': 'Список доставки',
  'menu.delivery': 'Доставка',
  'menu.receipt': 'Друк чека/етикетки',
  'menu.definitions': 'Визначення',
  'menu.customers': 'Клієнти',
  'menu.products': 'Визначення продуктів',
  'menu.pricing': 'Визначення цін',
  'menu.tailoring': 'Кравецькі операції',
  'menu.attributes': 'Атрибути продуктів',
  'menu.users': 'Користувачі',
  'menu.productOrdering': 'Порядок продуктів',
  'menu.discounts': 'Визначення знижок',
  'menu.settings': 'Налаштування',
  'menu.generalSettings': 'Загальні налаштування',
  'menu.permissions': 'Управління дозволами',
  'menu.subscription': 'Підписка',
  'menu.invoices': 'Управління рахунками',
  'menu.expenses': 'Введення витрат',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Звіти та бухгалтерія',
  'menu.systemAndCommunication': 'Система та зв’язок',
  'menu.reportsList': 'Список чеків',
  'menu.accountStatement': 'Виписка з рахунку',
  'menu.tickets': 'Запити підтримки',
  'menu.support': 'Підтримка',
  'menu.profile': 'Профіль',
  'menu.logout': 'Вихід',
  'menu.notifications': 'Сповіщення SMS/WhatsApp',
  'menu.whatsappConnection': 'Підключення WhatsApp',
  'menu.smsConnection': 'Підключення SMS',
  'dashboard.title': 'Панель керування',
  'dashboard.todaySales': 'Продажі сьогодні',
  'dashboard.totalOrders': 'Всього замовлень',
  'dashboard.pendingDeliveries': 'Очікують доставки',
  'dashboard.activeCustomers': 'Активні клієнти',
  'dashboard.recentOrders': 'Останні замовлення',
  'dashboard.viewAll': 'Переглянути все',
  'dashboard.quickActions': 'Швидкі дії',
  'dashboard.newOrder': 'Нове замовлення',
  'dashboard.newCustomer': 'Новий клієнт',
  'dashboard.deliveries': 'Доставки',
  'dashboard.reports': 'Звіти',
  'dashboard.today': 'Сьогодні',
  'dashboard.yesterday': 'Вчора',
  'dashboard.week': 'Тиждень',
  'dashboard.month': 'Місяць',
  'dashboard.quarter': 'Квартал',
  'dashboard.year': 'Рік',
  'dashboard.totalRevenue': 'Загальний дохід',
  'dashboard.totalOrdersCard': 'Всього замовлень',
  'dashboard.totalPieces': 'Всього позицій',
  'dashboard.cancelled': 'Скасовано',
  'dashboard.inProcess': 'В обробці',
  'dashboard.inProcessDesc': 'Замовлення в обробці',
  'dashboard.ready': 'Готово',
  'dashboard.readyDesc': 'Замовлення готові до доставки',
  'dashboard.delivered': 'Доставлено',
  'dashboard.deliveredDesc': 'Завершені замовлення',
  'dashboard.announcements': 'Оголошення',
  'dashboard.announcementAll': 'Загальні',
  'dashboard.announcementPrivate': 'Приватні',
  'order.title': 'Нове замовлення',
  'order.customer': 'Клієнт',
  'order.selectCustomer': 'Вибрати клієнта',
  'order.newCustomer': 'Новий клієнт',
  'order.products': 'Продукти',
  'order.addProduct': 'Додати продукт',
  'order.selectProduct': 'Вибрати продукт',
  'order.quantity': 'Кількість',
  'order.price': 'Ціна',
  'order.total': 'Всього',
  'order.discount': 'Знижка',
  'order.subtotal': 'Проміжний підсумок',
  'order.tax': 'ПДВ',
  'order.grandTotal': 'Загальна сума',
  'order.payment': 'Оплата',
  'order.paymentMethod': 'Спосіб оплати',
  'order.cash': 'Готівка',
  'order.card': 'Кредитна картка',
  'order.credit': 'Кредит',
  'order.amountPaid': 'Сплачена сума',
  'order.remainingBalance': 'Залишок',
  'order.deliveryDate': 'Дата доставки',
  'order.notes': 'Примітки',
  'order.createOrder': 'Створити замовлення',
  'order.cancel': 'Скасувати',
  'users.title': 'Користувачі',
  'users.addNew': 'Новий користувач',
  'users.name': 'Ім\'я',
  'users.email': 'Email',
  'users.role': 'Роль',
  'users.pin': 'PIN',
  'users.permissions': 'Дозволи',
  'users.allPermissions': 'Всі дозволи',
  'users.permissionCount': '{count} дозволів',
  'users.changePin': 'Змінити PIN',
  'users.edit': 'Редагувати',
  'users.delete': 'Видалити',
  'users.newUser': 'Новий користувач',
  'users.editUser': 'Редагувати користувача',
  'users.editingUser': 'Редагування {name}',
  'users.deleteUserTitle': 'Видалити користувача',
  'users.deletingUser': 'Ви впевнені, що хочете видалити {name}?',
  'users.pinCode': 'PIN-код (4-6 цифр)',
  'users.selectRole': 'Виберіть роль',
  'users.patron': 'Власник',
  'users.kasiyer': 'Касир',
  'users.sofor': 'Водій',
  'users.eleman': 'Працівник',
  'users.changePinTitle': 'Змінити PIN-код',
  'users.newPin': 'Новий PIN-код',
  'users.confirmPin': 'Підтвердити PIN-код',
  'users.pinMismatch': 'PIN-коди не співпадають',
  'users.pinRequired': 'Потрібен PIN-код',
  'users.pinLength': 'PIN-код має містити 4-6 цифр',
  'users.changingPinFor': 'Зміна PIN для {name}',
  'products.title': 'Визначення продуктів',
  'products.addNew': 'Новий продукт',
  'products.category': 'Категорія',
  'products.name': 'Назва продукту',
  'products.price': 'Ціна',
  'products.color': 'Колір',
  'products.active': 'Активний',
  'products.actions': 'Дії',
  'products.search': 'Пошук продукту...',
  'products.noProducts': 'Продукти не знайдено',
  'products.noCategoryProducts': 'У цій категорії немає продуктів',
  'products.emptyCart': 'Кошик порожній',
  'service.tailor': 'Кравець',
  'service.dryCleaning': 'Хімчистка',
  'service.washing': 'Прання',
  'service.ironing': 'Прасування',
  'service.shoeShine': 'Чистка взуття',
  'service.carpet': 'Килим',
  'service.tailoring': 'Кравецькі зміни',
  'service.carpetWashing': 'Прання килимів',
  'service.selectService': 'Виберіть послугу',
  'service.addToCart': 'Додати в кошик',
  'service.total': 'Всього',
  'common.yes': 'Так',
  'common.no': 'Ні',
  'common.cancel': 'Скасувати',
  'common.confirm': 'Підтвердити',
  'common.delete': 'Видалити',
  'common.edit': 'Редагувати',
  'common.save': 'Зберегти',
  'common.search': 'Пошук',
  'common.loading': 'Завантаження...',
  'common.noData': 'Немає даних',
  'common.actions': 'Дії',
  'common.status': 'Статус',
  'common.date': 'Дата',
  'common.time': 'Час',
  'common.total': 'Всього',
  'common.filter': 'Фільтр',
  'common.export': 'Експорт',
  'common.print': 'Друк',
  'common.close': 'Закрити',
  'common.back': 'Назад',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Відправити',
  'common.reset': 'Скинути',
  'common.create': 'Створити',
  'common.creating': 'Створення...',
  'common.later': 'Пізніше',
  'common.clear': 'Очистити',
  'common.copied': 'Скопійовано!',
  'common.copyError': 'Помилка копіювання',
  'common.autoDetected': 'Автоматично виявлено',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Система управління хімчисткою',
  'login.tenantId': 'ID компанії',
  'login.tenantPlaceholder': 'id-компанії (приклад: acme-clean)',
  'login.tenantIdHelp': 'Введіть унікальний ідентифікатор компанії',
  'login.continue': 'Продовжити →',
  'login.notMember': 'Ще не є членом?',
  'login.startTrial': 'Почати безкоштовну пробну версію',
  'login.adminLogin': '🔒 Вхід адміністратора',
  'login.enterPin': 'Введіть свій PIN-код',
  'login.changeTenant': 'Змінити компанію',
  'login.clear': 'Очистити',
  'login.delete': 'Видалити',
  'login.login': 'Увійти',
  'login.loggingIn': 'Вхід...',
  'login.defaultPinOwner': 'PIN за замовчуванням: <strong>1234</strong> (Власник)',
  'login.defaultPinCashier': 'PIN за замовчуванням: <strong>0000</strong> (Касир)',
  'login.systemInitializing': 'Ініціалізація системи...',
  'login.pinMinLength': 'PIN має містити принаймні 4 цифри',
  'login.invalidTenantId': 'Введіть дійсний ID компанії',
  'login.tenantNotFound': 'Цей код компанії не знайдено. Перевірте або створіть новий обліковий запис.',
  'login.loginFailed': 'Вхід не вдався',
  'login.welcome': 'Ласкаво просимо, {name}',
  'login.tagline': 'Програма для хімчистки — Розумні та прості рішення для вашого бізнесу',
  'signup.title': 'Почати безкоштовну пробну версію',
  'signup.subtitle': '15 днів безкоштовно, кредитна картка не потрібна',
  'signup.backToLogin': 'Повернутися на сторінку входу',
  'signup.companyCode': 'Код компанії',
  'signup.companyCodePlaceholder': 'приклад: cleanpro',
  'signup.companyCodeHelp': 'Цей код буде використовуватися для входу в систему',
  'signup.companyCodeMinLength': 'Код компанії має містити принаймні 3 символи',
  'signup.companyName': 'Назва компанії',
  'signup.companyNamePlaceholder': 'Назва вашої компанії',
  'signup.companyNameRequired': 'Назва компанії обов\'язкова',
  'signup.fullName': 'Повне ім\'я',
  'signup.fullNamePlaceholder': 'Ваше повне ім\'я',
  'signup.fullNameRequired': 'Повне ім\'я обов\'язкове',
  'signup.phone': 'Телефон',
  'signup.phonePlaceholder': '+380 50 123 4567',
  'signup.validPhoneRequired': 'Введіть дійсний номер телефону',
  'signup.email': 'Email',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Введіть дійсну адресу email',
  'signup.createAccount': 'Створити обліковий запис',
  'signup.creating': 'Створення...',
  'signup.terms': 'Створюючи обліковий запис, ви погоджуєтесь з Умовами обслуговування та Політикою конфіденційності.',
  'signup.success': 'Реєстрація успішна! Ваші дані для входу надіслані на вашу електронну адресу.',
  'signup.successTitle': 'Реєстрація успішна!',
  'signup.successMessage': 'Ваш обліковий запис успішно створено.',
  'signup.emailSent': 'Ваші дані для входу надіслані на вашу електронну адресу.',
  'signup.redirecting': 'Перенаправлення на сторінку входу...',
  'signup.startupPackageLoaded': 'Стартовий пакет завантажено!',
  'signup.products': 'Продукти',
  'signup.customers': 'Клієнти',
  'signup.users': 'Користувачі',
  'signup.demoDataReady': '✨ Ваші демонстраційні дані готові, ви можете почати використовувати їх негайно!',
  'signup.loginInfo': '📧 Ваші дані для входу',
  'signup.loginInfoSent': '💡 Ця інформація також надіслана на вашу електронну адресу',
  'signup.loginNow': 'Увійти зараз →',
  'expenses.expenseType': 'Тип витрат',
  'expenses.allBranches': 'Усі філії',
  'expenses.noBranch': 'Без філії',
  'expenses.allTypes': 'Усі типи',
  'expenses.categoryBy': 'За категоріями',
  'expenses.records': 'записів',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Не вдалося створити файл Excel',
  'expenses.branchSelect': 'Виберіть філію',
  'expenses.noBranchSelected': '— Філія не вибрана —',
  'expenses.myBranch': 'Моя філія',
  'expenses.canOnlyDeleteToday': 'Ви можете видаляти лише витрати, введені сьогодні.',
};
